import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import LaporanProduksiPage from "@/pages/LaporanProduksiPage";
import TambakPage from "@/pages/TambakPage";
import GudangPage from "@/pages/GudangPage";
import PanenPage from "@/pages/PanenPage";
import KeuanganPage from "@/pages/KeuanganPage";
import AIAnalisisPage from "@/pages/AIAnalisisPage";
import UserManagementPage from "@/pages/UserManagementPage";
import SiklusPage from "@/pages/SiklusPage";
import AuditLogPage from "@/pages/AuditLogPage";
import AnalyticsPage from "@/pages/AnalyticsPage";
import ProfilPage from "@/pages/ProfilPage";
import JadwalPage from "@/pages/JadwalPage";
import LabaRugiPage from "@/pages/LabaRugiPage";
import PurchaseOrderPage from "@/pages/PurchaseOrderPage";
import InvoicePage from "@/pages/InvoicePage";
import AkuntansiPage from "@/pages/AkuntansiPage";
import SimpananPage from "@/pages/SimpananPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="flex flex-col items-center gap-3">
          <div className="w-8 h-8 border-2 border-[#B8860B] border-t-transparent rounded-full animate-spin" />
          <p className="text-sm text-slate-500">Memuat...</p>
        </div>
      </div>
    );
  }
  if (!user || user === false) return <Navigate to="/login" replace />;
  return children;
}

function RoleRoute({ children, roles, allowPermission }) {
  const { user } = useAuth();
  if (allowPermission && user?.[allowPermission]) return children;
  if (roles && !roles.includes(user?.role)) return <Navigate to="/" replace />;
  return children;
}

const KOPERASI = ["admin","manager","pengurus"];

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && user !== false) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path="/login"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/laporan" element={<RoleRoute roles={KOPERASI}><LaporanProduksiPage /></RoleRoute>} />
            <Route path="/tambak" element={<TambakPage />} />
            <Route path="/siklus" element={<SiklusPage />} />
            <Route path="/gudang" element={<RoleRoute roles={KOPERASI}><GudangPage /></RoleRoute>} />
            <Route path="/panen" element={<RoleRoute roles={KOPERASI}><PanenPage /></RoleRoute>} />
            <Route path="/keuangan" element={<RoleRoute roles={KOPERASI}><KeuanganPage /></RoleRoute>} />
            <Route path="/ai-analisis" element={<RoleRoute roles={KOPERASI}><AIAnalisisPage /></RoleRoute>} />
            <Route path="/pengguna" element={<RoleRoute roles={["admin","manager"]} allowPermission="can_manage_users"><UserManagementPage /></RoleRoute>} />
            <Route path="/audit-log" element={<RoleRoute roles={KOPERASI}><AuditLogPage /></RoleRoute>} />
            <Route path="/analytics" element={<RoleRoute roles={KOPERASI}><AnalyticsPage /></RoleRoute>} />
            <Route path="/profil" element={<RoleRoute roles={KOPERASI}><ProfilPage /></RoleRoute>} />
            <Route path="/jadwal" element={<JadwalPage />} />
            <Route path="/laba-rugi" element={<RoleRoute roles={KOPERASI}><LabaRugiPage /></RoleRoute>} />
            <Route path="/purchase-orders" element={<RoleRoute roles={KOPERASI}><PurchaseOrderPage /></RoleRoute>} />
            <Route path="/invoices" element={<RoleRoute roles={KOPERASI}><InvoicePage /></RoleRoute>} />
            <Route path="/akuntansi" element={<RoleRoute roles={KOPERASI}><AkuntansiPage /></RoleRoute>} />
            <Route path="/simpanan" element={<RoleRoute roles={KOPERASI}><SimpananPage /></RoleRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
